import React from 'react';
import GameCategoriesState from './gameCategoriesState/GameCategoriesState';
import GameCategoriesControlPanel from './components/GameCategoriesControlPanel/GameCategoriesControlPanel';
import GameCategories from './components/GameCategories/GameCategories';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const GameCategoriesPage: React.FC = () => {
	return (
		<GameCategoriesState>
			<div className={style.container} data-test="GameCategoriesPage">
				<GameCategoriesControlPanel />
				<GameCategories />
				<ModalWindows />
			</div>
		</GameCategoriesState>
	);
};

export default GameCategoriesPage;
